import { jsonTryParse } from '../json/json-try-parse'

export const buildQueryVariables = (
  skip: number,
  searchString: string | Record<any, any>,
  sortObject: Record<any, any>,
  limit: number,
  dbOptions: Record<any, any> | null = {}
) => {
  //prepare for the variableOptions — guard against NaN/negative/non-finite (NaN is truthy, so `|| 0` fails)
  skip = Number.isFinite(skip) && skip >= 0 ? skip : 0
  //if the limit null or zero, it mean it should get all records
  if (limit === null || limit === 0) {
    limit = 0
  } else {
    //if limit is undefined or non-finite then use the default, else use the provided limit
    limit = Number.isFinite(limit) && limit > 0 ? limit : 10
  }

  const page = { skip, limit }

  let options = sortObject
  if (!options) {
    options = page
  } else {
    options = Object.assign(options, page)
  }

  options = { ...options, ...dbOptions }

  //empty searchString will be converted to empty object
  const filter = jsonTryParse(searchString)

  return { filter, options }
}
